<template>
  <v-sheet color="white" class="activePosition">
    <v-stepper v-if="!(isAdmin && isCommon)" app :value="step" :model-value="step" @input="updateStep"
      color="secondary">
      <v-stepper-header>
        <!-- STEP DEFINITION -->
        <v-stepper-item v-if="!hideDefinition" :complete="editableSteps.definition > 0"
          :editable="!disabled && editableSteps.definition > 0 && step != '1'" value="1" color="secondary"
          @click="goToStep('definition')">
          {{ $t("labels.definition") }}
        </v-stepper-item>
        <v-divider v-if="!hideDefinition"></v-divider>

        <!-- STEP FORMULA -->
        <v-stepper-item v-if="!isManualKpi" :complete="editableSteps.formula > 0" :value="formulaStepValue"
          :editable="!disabled && editableSteps.formula > 0 && step != formulaStepValue" color="secondary"
          @click="goToStep('formula')">
          {{ $t("labels.formula") }}
        </v-stepper-item>
        <v-divider v-if="!isManualKpi"></v-divider>

        <!-- STEP DASHBOARD -->
        <v-stepper-item :complete="editableSteps.dashboard > 0" :value="dashboardStepValue"
          :editable="!disabled && editableSteps.dashboard > 0 && step != dashboardStepValue" color="secondary"
          @click="goToStep('dashboard')">
          {{ $t("labels.dashboard") }}
        </v-stepper-item>
        <v-divider></v-divider>

        <!-- STEP SUMMARY -->
        <v-stepper-item :complete="editableSteps.summary > 0" :value="summaryStepValue"
          :editable="!disabled && editableSteps.summary > 0 && step != summaryStepValue" color="secondary"
          @click="goToStep('summary')">
          {{ $t("labels.summary") }}
        </v-stepper-item>
      </v-stepper-header>
    </v-stepper>
  </v-sheet>
</template>

<script>
export default {
  props: {
    step: {
      type: String,
      default: "1"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isCommon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editableSteps: {
        definition: 0,
        formula: 0,
        dashboard: 0,
        summary: 0,
      },
    };
  },
  computed: {
    hideDefinition() {
      return this.isAdmin && this.isCommon && !this.isManualKpi;
    },
    isManualKpi() {
      try {
        const kpi = JSON.parse(sessionStorage.getItem("kpi"));
        if (!kpi) return false;
        const type = ((kpi.kpiType || kpi.type) || "").toString();
        return /manu/i.test(type);
      } catch (_e) {
        return false;
      }
    },

    formulaStepValue() {
      return this.hideDefinition ? "1" : "2";
    },
    dashboardStepValue() {
      if (this.hideDefinition) {
        return this.isManualKpi ? "1" : "2";
      }
      return this.isManualKpi ? "2" : "3";
    },
    summaryStepValue() {
      if (this.hideDefinition) {
        return this.isManualKpi ? "2" : "3";
      }
      return this.isManualKpi ? "3" : "4";
    },
  },
  created() {
    this.updateEditableSteps();
  },
  mounted() {
    this.eventListener = (event) => {
      this.setEditableStep(event.detail.step, event.detail.value);
    };
    document.addEventListener("editable-steps", this.eventListener);
  },
  beforeUnmount() {
    document.removeEventListener("editable-steps", this.eventListener);
  },
  updated() {
    this.updateEditableSteps();
  },
  methods: {
    routeTo(path) {
      this.$router.push({ path });
    },
    goToStep(key) {
      if (this.disabled) return;
      if (this.editableSteps[key] > 0) {
        this.routeTo(`/editor/${key}`);
      }
    },
    updateStep(newValue) {
      if (this.disabled) return;
      this.$emit("update:step", newValue);
    },
    updateEditableSteps() {
      const kpi = JSON.parse(sessionStorage.getItem("kpi"));
      let keys = Object.keys(this.editableSteps);
      let foundAllExceptSummary = true;

      if (kpi) {
        for (let key of keys) {
          if (key === "formula" && this.isManualKpi) {
            this.editableSteps[key] = 0;
            continue;
          }
          if (key in kpi) {
            this.editableSteps[key] = 1;
          } else {
            if (key !== "summary" && !(key === "formula" && this.isManualKpi)) {
              foundAllExceptSummary = false;
            }
          }
        }
        if (foundAllExceptSummary) {
          this.editableSteps["summary"] = 1;
        }
      }
    },
    setEditableStep(step, value) {
      this.editableSteps[step] = value;
    },
  },
};
</script>